let url = "";

if (process.env.NODE_ENV === "development") {
    url = "http://localhost:5200";
} else {
    url = "https://api.bmclubusa.com";
}

export const Constants = {
    url,
    baseUrl: url.concat("/api/admin"),
    devTrack: {
        deadlineOptions: [
            { value: 0, label: "Livre" },
            { value: 30, label: "30 dias" },
            { value: 60, label: "60 dias" },
            { value: 90, label: "90 dias" },
        ],
        contentTypeOptions: [
            { value: "text", label: "Texto" },
            { value: "video", label: "Vídeo" },
        ],
    },
    customer: {
        personalSubPlanName: {
            MONTHLY: "Mensal",
            YEARLY: "Anual",
        },
    },
    enumStatus: {
        status: {
            ACTIVE: { value: "ACTIVE", label: "Active", color: "success" },
            EXPIRED: { value: "EXPIRED", label: "Expired", color: "danger" },
            INACTIVE: { value: "INACTIVE", label: "Inactive", color: "danger" },
            AVAILABLE: { value: "AVAILABLE", label: "Available", color: "gray" },
            SOLD_OUT: { value: "SOLD_OUT", label: "Sold Out", color: "danger" },
            CANCELED: { value: "CANCELED", label: "Canceled", color: "warning" },
            FINISHED: { value: "FINISHED", label: "Finished", color: "success" },
            BLOCKED: { value: "BLOCKED", label: "Blocked", color: "warning" },
            CONFIRMED: { value: "CONFIRMED", label: "Confirmed", color: "success" },
            DELETED: { value: "DELETED", label: "Deleted", color: "warning" },
            PENDING_APPROVAL: { value: "PENDING_APPROVAL", label: "Pending approval", color: "danger" },
            DENIED: { value: "DENIED", label: "Denied", color: "warning" },
        },
        postStatus: {
            POSTED: { value: "POSTED", label: "Posted", color: "success" },
            DELETED: { value: "DELETED", label: "Deleted", color: "warning" },
        },
        commonStatusOptions: [
            { value: "ACTIVE", label: "Active" },
            { value: "DELETED", label: "Deleted" },
        ],
        secondaryStatusOptions: [
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
        ],
    },
    renewalPeriods: [
        { value: "semi_annually", label: "6 month" },
        { value: "annually", label: "9 months" },
        { value: "biennially", label: "12 months" },
        { value: "quinquennially", label: "15 months" },
        { value: "octodecennial", label: "18 months" },
    ],
    post: {
        categoryLabels: {
            BM_CLUB: "BM Club",
            GALLERIA: "Galleria",
            POST_TEXT: "Community",
        },
        originLabels: {
            ADMIN: "Admin",
            MEMBER: "Member",
        },
        reactLabels: {
            LIKE: "Like",
            LOVE: "Love",
            CONGRATS: "Congrats",
            GREAT: "Great",
            GENIUS: "Genius",
        },
    },
};
